import { Injectable, inject } from '@angular/core';
import { create } from '@bufbuild/protobuf';
import {
  ProjectServiceListRequestSchema,
  SortDirection,
} from '@vmspdb/definitions';
import { SelectOption } from '@vmspdb/ui/domain';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProjectRepositoryService } from '../repositories';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private projects = inject(ProjectRepositoryService);

  getSingleProject(uuid: string): Observable<SelectOption> {
    return this.projects.fetch(uuid).pipe(
      map((document) => ({
        label: `${document.name} (${document.jobNumber})`,
        value: `${document.uuid}`,
      })),
    );
  }

  filterProjects(term: string): Observable<SelectOption[]> {
    const year = new Date().getFullYear().toString().substring(2) + '-';

    return this.projects
      .list(
        create(ProjectServiceListRequestSchema, {
          filter: term ? term : year,
          pageSize: 20,
          sortField: 'jobNumber',
          sortDirection: SortDirection.ASC,
          prefix: true,
        }),
      )
      .pipe(
        map((results) =>
          (results.items ?? []).map((hit) => ({
            label: `${hit.name} (${hit.jobNumber})`,
            value: `${hit.uuid}`,
          })),
        ),
      );
  }
}

export function projectProps(search: SearchService, all = true) {
  return {
    filter: (term: string) => {
      return search.filterProjects(term).pipe(
        map((options) =>
          all
            ? [
                {
                  label: 'All Projects',
                  value: '',
                },
                ...options,
              ]
            : options,
        ),
      );
    },
    format: (term: string) => {
      return term
        ? search.getSingleProject(term)
        : of({
            label: all ? 'All Projects' : '',
            value: '',
          });
    },
  };
}
